import styled from "styled-components";
import { type SpaceProps, space } from "styled-system";
import CommonLabel from "../../../../../../../../common-deprecated/styles/v2/lexus/components/Label";
import { theme } from "../../../../../../../../common-deprecated/styles/v2/lexus/theme/lexusTheme";
import {
    bodyStyle,
    h5Style,
    type TextStyleType,
} from "../../../../../../../../common-deprecated/styles/v2/lexus/globals/Type";

export const Label = styled(CommonLabel)<TextStyleType & SpaceProps>`
    margin: ${theme.space[2]}px 0;
    text-transform: uppercase;
    color: ${theme.colors.midnight};
    ${h5Style};
    ${space};
`;

export const IconWrapper = styled.div`
    width: 20px;
    height: 20px;
    margin-top: 2px;
    color: ${theme.colors.steel};
`;

export const SearchTextButton = styled.button<TextStyleType>`
    display: flex;
    justify-content: space-between;
    width: 100%;
    padding: 12px 20px 12px 20px;
    color: ${theme.colors.platinumDark};
    background: ${theme.colors.white};
    border: 1px solid ${theme.colors.platinumLight};
    border-radius: 0;
    ${bodyStyle};
`;
